import React from "react";

const IntermediateContainer = () => {
  return (
    <>
      <div className="flex flex-col gap-5 w-[694px] px-2">
        <div className="flex flex-col gap-4">
          <h1 className="text-[28px] font-semibold border-b-[1px] border-gray-400">
            12th Class (Intermediate)
          </h1>
          <p className="text-[15px] font-medium">
            <h1 className="text-[17px] font-semibold text-amber-700 pb-2">
              Intermediate Examination Certificate (ICE)
            </h1>
            "ICE" means Intermediate Certificate Examination (i.e. XII
            -Examination). The examinations are conducted twice in a year in
            accordance with the syllabi prescribed by the Board. 20 marks of
            continuous & comprehensive evaluation have been allotted in each
            subject. After passing the examination, a certificate of
            qualification is awarded by the Board.
            <h1 className="text-[17px] font-semibold text-amber-700 py-2">
              Eligibility Criteria
            </h1>
            In the senior/ higher secondary school certificate course those who
            have completed 16 years of age as on 1st August of the year in which
            admission is sought for after qualifying in the entrance test
            prescribed to pursue senior/ higher secondary courses under the open
            distance learning mode.
          </p>
        </div>
      </div>
    </>
  );
};

export default IntermediateContainer;
